import React from "react"
import { ChevronRight } from "react-bootstrap-icons"

function Breadcrumb(props: any) {
    return (
        <div className="breadcrumb-detail d-flex my-3">
            <div className="breadcrumb-heading">{props.title}</div>
            <ChevronRight color="#7888A7" size={12} className="breadcrumb-arrow my-2 mx-2" />
            {props.subTitle.map((title: string, index: number) => (
                <>
                    <div className="breadcrumb-heading ml-3" key={index + "title"}>
                        {title}
                    </div>
                    {index !== props.subTitle.length - 1 ? (
                        <ChevronRight
                            color="#7888A7"
                            size={12}
                            className="breadcrumb-arrow my-2 mx-2"
                            key={index + "arrow"}
                        />
                    ) : (
                        ""
                    )}
                </>
            ))}
        </div>
    )
}

export default Breadcrumb
